import { IconBook, IconPlus } from '@tabler/icons-react';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { getPrograms } from '../../store/programSlice';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';

const ProgramCard = ({ program }) => (
    <Link
        to={`/curriculum/programs/${program.id}`}
        className="text-primary hover:text-primary/80"
    >
        <Card
            key={program.id}
            className="h-full cursor-pointer transition-all duration-200 hover:shadow-lg border-border hover:border-primary/20"
        >
            {program.image && (
                <div className="aspect-video w-full overflow-hidden rounded-t-lg">
                    <img
                        src={program.image}
                        alt={program.name}
                        className="h-full w-full object-cover"
                    />
                </div>
            )}
            <CardHeader>
                <CardTitle className="flex items-center gap-2">
                    {program.name}
                </CardTitle>
            </CardHeader>
            <CardContent>
                <CardDescription className="text-muted-foreground mb-2">
                   {program.description || 'No description available'}
                </CardDescription>
                <CardDescription className="text-muted-foreground">
                    {program.courseCount} courses
                </CardDescription>
            </CardContent>
        </Card>
    </Link>
);

export default function Curriculum() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const programs = useSelector(state => state.program.list);
    const loading = useSelector(state => state.program.loading);

    useEffect(() => {
        dispatch(getPrograms());
    }, [dispatch]);

    const handleAddProgram = () => {
        navigate('/curriculum/programs/new');
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="text-muted-foreground">Loading programs...</div>
            </div>
        );
    }

    return (
        <div className="space-y-6">
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-3xl font-bold tracking-tight">Curriculum</h1>
                    <p className="text-muted-foreground">
                        Manage your learning programs and courses
                    </p>
                </div>
                <Button onClick={handleAddProgram}>
                    <IconPlus className="mr-2 h-4 w-4" />
                    Add Program
                </Button>
            </div>

            <div className="grid gap-6 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
                {programs.map((program) => (
                    <ProgramCard key={program.id} program={program} />
                ))}
            </div>
        </div>
    );
} 